document.addEventListener('DOMContentLoaded', function() {
  // Find ALL localization forms on the page (for desktop and mobile)
  const forms = document.querySelectorAll('form.shopify-localization-form');

  // If no forms are found, do nothing.
  if (!forms.length) {
    return;
  }

  // Apply the interactive logic to EACH form found
  forms.forEach(function(form) {
    const button = form.querySelector('button');
    const panel = form.querySelector('ul');
    const input = form.querySelector('input[name="country_code"]');

    if (!button || !panel || !input) return;

    // --- Toggles the dropdown when the button is clicked ---
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const isHidden = panel.hidden;

      // Close all other open forms on the page
      forms.forEach(f => {
        if (f !== form) {
          f.querySelector('ul').hidden = true;
          f.querySelector('button').setAttribute('aria-expanded', 'false');
        }
      });
      
      // Toggle the current form's panel
      panel.hidden = !isHidden;
      button.setAttribute('aria-expanded', !isHidden);
    });

    // --- Handles country selection from the list ---
    panel.addEventListener('click', function(event) {
      const link = event.target.closest('a');
      if (link) {
        event.preventDefault();
        input.value = link.dataset.value;
        form.submit();
      }
    });
  });

  // --- Closes all dropdowns when clicking anywhere else on the page ---
  document.addEventListener('click', function(event) {
    if (!event.target.closest('form.shopify-localization-form')) {
      forms.forEach(function(form) {
        form.querySelector('ul').hidden = true;
        form.querySelector('button').setAttribute('aria-expanded', 'false');
      });
    }
  });
});